var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"fit-content"}},[_c('Header'),_c('router-view'),_c('Footer',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.meta.footer),expression:"$route.meta.footer"}]})],1)}
var staticRenderFns = []

export { render, staticRenderFns }